import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}/auth`;

const login = async ({ email, password }) => {
  const { data: token } = await axios.post(`${apiUrl}/login`, {
    email,
    password
  });

  return { token };
};

const googleLogin = async ({ code }) => {
  const { data: { token } } = await axios.post(`${apiUrl}/google/login`, { code });

  return { token };
};

const fetchUserFromToken = async () => {
  const { data: user } = await axios.get(`${apiUrl}/me`);

  return { user };
};

const updatePassword = async ({ userId, password }) => {
  await axios.post(`${apiUrl}/update-password`, {
    userId,
    password
  });

  return;
};

const resetPassword = async ({ forgotPasswordRequestId, newPassword }) => {
  const response = await axios.post(`${apiUrl}/reset-password`, {
    forgotPasswordRequestId,
    newPassword
  });

  return response;
};

const createForgotPasswordRequest = async ({ userEmail }) => {
  const response = await axios.post(`${apiUrl}/forgot-password`, { email: userEmail });

  return response;
};

const fetchForgotPasswordRequest = async ({ forgotPasswordRequestId }) => {
  const response = await axios.get(`${apiUrl}/forgot-password/${forgotPasswordRequestId}`);

  return response;
};

const getGoogleAuthUrl = async ({ redirectUri }) => {
  const response = await axios.post(`${apiUrl}/google`, { redirectUri });

  return response;
};

const linkGoogleAccount = async ({ code, userId, redirectUri }) => {
  const response = await axios.post(`${apiUrl}/google/link-account`, {
    code,
    userId,
    redirectUri
  });

  return response;
};

const apiService = {
  login,
  googleLogin,
  fetchUserFromToken,
  updatePassword,
  resetPassword,
  createForgotPasswordRequest,
  fetchForgotPasswordRequest,
  getGoogleAuthUrl,
  linkGoogleAccount
};

export default apiService;
